import { render } from "./EditCompanyModal.vue?vue&type=template&id=efaf9ac6"
import script from "./EditCompanyModal.vue?vue&type=script&lang=js"
export * from "./EditCompanyModal.vue?vue&type=script&lang=js"

import "./EditCompanyModal.vue?vue&type=style&index=0&id=efaf9ac6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__